module.exports = "/assets/f4a70a28609156f1f53d4b1023ce8e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DL.png
// module id = 1305
// module chunks = 0